import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TwoStepDepositDataService } from '@views/modules/member/services/two-step-deposit-data.service';
import { TwoStepDepositService } from '@views/modules/member/services/two-step-deposit.service';
import { AudBankTransferDepositService } from '@views/modules/member/services/aud-banktrasfer-deposit.service';
import { AudBankTransferDepositDataService } from '@views/modules/member/services/aud-banktrasfer-deposit-data.service';
@Injectable({
  providedIn: 'root',
})
export class DepositDeactivateGuard implements CanDeactivate<any> {
  constructor(
    private twoStepDepositService: TwoStepDepositService,
    private twoStepDepositDataService: TwoStepDepositDataService,
    private audBankTransferDepositService: AudBankTransferDepositService,
    private audBankTransferDepositDataService: AudBankTransferDepositDataService,
) {}

  async canDeactivate(component: any): Promise<boolean> {
    const lsStepTwoDeposit =
      this.twoStepDepositDataService.getLSStepTwoDeposit();

    if (lsStepTwoDeposit) {
        return this.twoStepDepositService.handleLeavingStepTwoPage(lsStepTwoDeposit);
    }

    const lsAudStepTwoDeposit = this.audBankTransferDepositDataService.getAudTransferDeposit();
    if (lsAudStepTwoDeposit) {
      return this.audBankTransferDepositService.handleLeavingAudTransferPage(lsAudStepTwoDeposit);
    }

    // user didn't have any pending callback deposit
    return true;
  }
}
